var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFlashIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9004 0.448646C3.97863 0.182657 4.22275 0 4.50001 0H9.50001C9.70091 0 9.88956 0.0965758 10.007 0.259556C10.1245 0.422536 10.1565 0.63205 10.0929 0.822642L7.86715 7.5H12.625C12.8637 7.5 13.0816 7.63597 13.1865 7.85041C13.2913 8.06484 13.2649 8.32029 13.1184 8.50871L4.36835 19.7587C4.18311 19.9969 3.85418 20.0687 3.58652 19.9294C3.31886 19.7902 3.18891 19.4796 3.27764 19.1912L5.52878 11.875H1.37501C1.17803 11.875 0.992587 11.7821 0.874582 11.6244C0.756577 11.4667 0.719823 11.2626 0.775402 11.0736L3.9004 0.448646Z",
    fill: "#1876D2",
    fillOpacity: 0.49
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9004 0.448646C3.97863 0.182657 4.22275 0 4.50001 0H9.50001C9.70091 0 9.88956 0.0965758 10.007 0.259556C10.1245 0.422536 10.1565 0.63205 10.0929 0.822642L7.86715 7.5H12.625C12.8637 7.5 13.0816 7.63597 13.1865 7.85041C13.2913 8.06484 13.2649 8.32029 13.1184 8.50871L4.36835 19.7587C4.18311 19.9969 3.85418 20.0687 3.58652 19.9294C3.31886 19.7902 3.18891 19.4796 3.27764 19.1912L5.52878 11.875H1.37501C1.17803 11.875 0.992587 11.7821 0.874582 11.6244C0.756577 11.4667 0.719823 11.2626 0.775402 11.0736L3.9004 0.448646ZM4.96765 1.25L2.2103 10.625H6.37501C6.57335 10.625 6.75991 10.7191 6.87775 10.8787C6.99558 11.0382 7.0307 11.2442 6.97237 11.4338L5.4752 16.2996L11.3471 8.75H7.00001C6.7991 8.75 6.61045 8.65342 6.49298 8.49044C6.37551 8.32746 6.34355 8.11795 6.40708 7.92736L8.63286 1.25H4.96765Z",
    fill: "#1876D2",
    fillOpacity: 0.49
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFlashIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/flash_icon.31cfe90e9d60d730b4c06b31a1cf795d.svg";